export enum ViewMode {
  store = "STORE",
  product = "PRODUCT",
};